import axios from "axios";

const API_URL = process.env.REACT_APP_DEVELOPMENT_API_URL + 'PatientCheckIn/LogPatientCheckIn';

const getSourceInfo = () => {
  const userAgent = navigator.userAgent;
  let browserName = 'Unknown Browser';
  let deviceInfo = 'Unknown Device';

  // Determine browser name
  if (userAgent.indexOf('Firefox') > -1) {
    browserName = 'Mozilla Firefox';
  } else if (userAgent.indexOf('SamsungBrowser') > -1) {
    browserName = 'Samsung Internet';
  } else if (userAgent.indexOf('Chrome') > -1) {
    browserName = 'Google Chrome';
  } else if (userAgent.indexOf('Safari') > -1) {
    browserName = 'Safari';
  } else if (userAgent.indexOf('Trident') > -1) {
    browserName = 'Internet Explorer';
  } else if (userAgent.indexOf('Edge') > -1) {
    browserName = 'Microsoft Edge';
  }

  // Determine device type
  if (/Mobi|Android/i.test(userAgent)) {
    deviceInfo = 'Mobile Device';
  } else {
    deviceInfo = 'Desktop';
  }

  return `${browserName} on ${deviceInfo}`;
};

export const logError = async ({
  message,
  exception,
  sessionID,
  source
}) => {
  // const source = getSourceInfo();
  const application = "OSPCI"
  const urNumber = 0
  const urID = "OSPCI"
  const company = "Enterprise"

  try {
    const response = await axios.post(API_URL, {
      application,
      urNumber,
      urID,
      company,
      source,
      message,
      exception,
      sessionID,
    }, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

  } catch (error) {
      console.error('Error setting up the request', error);
  }
};
